import { useCallback, useState } from 'react';

export const CHART_SCALE_MIN = 1;
export const CHART_SCALE_MAX = 4;
export const CHART_SCALE_STEP = 0.5;

export const useChartScale = () => {
  const [scale, setScale] = useState(CHART_SCALE_MIN);

  const scaleIn = useCallback(
    () =>
      setScale((current) =>
        Math.min(CHART_SCALE_MAX, current + CHART_SCALE_STEP),
      ),
    [],
  );

  const scaleOut = useCallback(
    () =>
      setScale((current) =>
        Math.max(CHART_SCALE_MIN, current - CHART_SCALE_STEP),
      ),
    [],
  );

  const reset = useCallback(() => setScale(CHART_SCALE_MIN), []);

  return {
    scale,
    scaleIn,
    scaleOut,
    reset,
    canScaleIn: scale < CHART_SCALE_MAX,
    canScaleOut: scale > CHART_SCALE_MIN,
  };
};
